@use '~/theme/theme' as *;

.content {
  padding-bottom: spacing(0.5);
}
